import { Component, HostListener, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
  PiSendOption,
  PiSendOptionsDialogService,
} from '../../services/pi-send-options-dialog.service';

/** PAT-305 — choose Send as-is vs Password-protect & send; editable report name. */
@Component({
  selector: 'app-pi-send-options-dialog',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './pi-send-options-dialog.component.html',
  styleUrl: './pi-send-options-dialog.component.scss',
})
export class PiSendOptionsDialogComponent {
  readonly dialog = inject(PiSendOptionsDialogService);
  readonly titleError = signal('');

  @HostListener('document:keydown.escape')
  onEscape(): void {
    if (!this.dialog.active()) return;
    this.onCancel();
  }

  onBackdropClick(): void {
    this.onCancel();
  }

  onCancel(): void {
    this.titleError.set('');
    this.dialog.resolve(null);
  }

  onTitleChange(value: string): void {
    this.dialog.draftTitle.set(value);
    this.titleError.set('');
  }

  onChoose(choice: PiSendOption): void {
    const title = this.dialog.draftTitle().trim();
    if (!title) {
      this.titleError.set('Enter a report name before sending.');
      return;
    }
    this.titleError.set('');
    this.dialog.resolve({ choice, title });
  }
}
